const resetPass = ( api, sendData, setPassword, setCode, setEmail, notifySuccess, notifyError, notifyInfo, setIsLoading, setCards ) => {


    api({
        method: 'post',
        url: 'newPass.php?fun=newpass',
        data: sendData,
    })
        .then((response) => {

            if (response.data.uspesno) {

                setEmail('');
                setPassword('');
                setCode('');
                notifySuccess(response.data.uspesno);
                setCards({ login: true })
                setIsLoading(false)

            } else if (response.data.greska) {
                notifyError(response.data.greska);
                setIsLoading(false)

            } else if (response.data.info) {
                notifyInfo(response.data.info);
                setIsLoading(false)
            }
        })
}

export default resetPass